module.exports = __webpack_public_path__ + "img/register.5ab51480.svg";